import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { common, financedEmissions } from "../../i18n";
import { AssetClass } from "../../models/dto/cat15/cat15.types";
import { assetClassLabelKey } from "./labels";

interface Props {
  assetClass: AssetClass;
  size?: "small" | "medium";
}

// business and listed colours come from Figma All Loans; project's was picked outside Figma
const styleByClass: Record<AssetClass, { color: string; bg: string }> = {
  business: {
    color: "var(--status-approved-complete-active-text)",
    bg: "var(--status-approved-complete-active-bg)",
  },
  listed: {
    color: "var(--status-owned-and-leased-out-text)",
    bg: "var(--status-owned-and-leased-out-bg)",
  },
  project: {
    color: "var(--status-project-finance-text)",
    bg: "var(--status-project-finance-bg)",
  },
};

const AssetClassChip = ({ assetClass, size = "small" }: Props) => {
  const { t } = useTranslation([financedEmissions, common], {
    nsMode: "fallback",
  });
  const s = styleByClass[assetClass];
  return (
    <Chip
      size={size}
      label={t(assetClassLabelKey(assetClass))}
      sx={{
        borderRadius: "10px",
        fontSize: "12px",
        fontWeight: 600,
        color: s.color,
        backgroundColor: s.bg,
      }}
    />
  );
};

export default AssetClassChip;
